import React from "react";
import './TestPage.css'

import Test from './../../components/Test';
//import ModalImage from "../../components/ModalImage";
//import Album from "./../../components/Album";
import Sidebar from "./../../components/Sidebar";
//import Footer from "./../../components/Footer";
//import Login from "./../../components/Login";
//import Carousel from "./../../components/Carousel";
//import Modal from "./../../components/Modal";
//import CustomCard from "./../../components/CustomCard";

// <Album />   <Footer />
const TestPage = () => {

  return (
    <>
        <div className="naastelkaar">
          <Sidebar />
          <Test />
        </div>
    </>
  );
};

export default TestPage;
